import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewChild } from "@angular/core";
import { EditableGridComponent } from "projects/sepidz-web-framework-data-grid/src/lib/editable-grid/editable-grid.component";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { form_control } from "projects/sepidz-web-framework/src/lib/models";
import { Dictionary } from "projects/sepidz-web-framework/src/lib/models/dictionary";
import { takeUntil } from "rxjs/operators";
import { GoodsUnit } from "../../../models/goods.model";
import { ProductConversionStandardHeader } from "../../../models/product-conversion-standard-header.model";

@Component({
  selector: "ngx-product-conversion-standard-form",
  templateUrl: "./product-conversion-standard-form.component.html",
  styleUrls: ["./product-conversion-standard-form.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductConversionStandardFormComponent extends BaseFormComponent<ProductConversionStandardHeader> {
  isloading: boolean = false;
  DefaultValues: Dictionary = [];
  @ViewChild("grid") public grid: EditableGridComponent;
  ProductConversionStandardDetailColumns: form_control[] = [];
  constructor(protected selectorService: SelectorService, protected cd: ChangeDetectorRef) {
    super(selectorService, cd);
  }
  async ngOnInit() {
    this.DefaultValues["ProductConversionStandardHeaderId"] = 0;
    this.apiName = "ProductConversionStandardHeader";
    this.label = this.translate("ClientApp.Pages.PageMenu.ProductConversionStandardTitle");
    super.ngOnInit();
  }
  setGoodsUnit() {
    this.httpCommonService
      .getList("Goods/ReadGoodsUnitLookUp/" + this.model.GoodsId)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((x) => {
        if (!(x as GoodsUnit[]).some((u) => u.UnitId === this.model.GoodsUnitId))
          (x as GoodsUnit[]).push({
            GoodsId: this.model.GoodsId,
            UnitId: this.model.GoodsUnitId,
            Ratio: 1,
            UnitTitle: this.model.GoodsUnitTitle,
            IsDefault: false,
            Id: 0,
          });
        this.selectorService.setDataList("GoodsUnitId", x as []);
      });
  }
  onChange($event) {
    if (this.isNewRow) {
      if ($event.apiName && $event.data && $event.data.Id && $event.apiName.includes("Goods/GetPagining")) {
        this.model.GoodsTitle = $event.data.Title;
        this.model.GoodsCode = $event.data.Code;
        this.model.GoodsId = $event.data.Id;
        this.model.GoodsUnitId = $event.data.UnitId;
        this.model.GoodsUnitTitle = $event.data.UnitTitle;
        this.model.GoodsUnitRatio = $event.data.DefaultUnitRatio;
        this.setValue("GoodsUnitRatio", this.model.GoodsUnitRatio);
        this.setValue("GoodsUnitId", this.model.GoodsUnitId);
        this.setValue("GoodsUnitTitle", this.model.GoodsUnitTitle);
        this.setGoodsUnit();
      }
      if ($event.apiName && $event.data && $event.data.Id && $event.apiName.includes("Goods/ReadGoodsUnitLookUp")) {
        this.model.GoodsUnitTitle = $event.data.UnitTitle;
        this.model.GoodsUnitRatio = $event.data.Ratio;
        this.setValue("GoodsUnitTitle", this.model.GoodsUnitTitle);
        this.setValue("GoodsUnitRatio", this.model.GoodsUnitRatio);
        this.setGoodsUnit();
      }
    }
  }
  setdefault() {
    if (!this.model.ProductConversionStandardDetails) this.model.ProductConversionStandardDetails = [];
  }
  addControl() {
    this.cd.markForCheck();
  }
  valueChanges(event) {
    if (event.Ratio) {
      this.grid.formGroup.get("GoodsUnitRatio").setValue(event.Ratio);
    }
    if (event.DefaultUnitId) {
      this.grid.formGroup.get("GoodsUnitRatio").setValue(event.DefaultUnitRatio);
      this.httpCommonService
        .getList("Goods/ReadGoodsUnitLookUp/" + event.Id)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((x) => {
          if (!(x as GoodsUnit[]).some((u) => u.UnitId === event.UnitId))
            (x as GoodsUnit[]).push({ GoodsId: event.Id, UnitId: event.UnitId, Ratio: 1, UnitTitle: event.UnitTitle, IsDefault: false, Id: 0 });
          this.selectorService.setDataList("Goods/ReadGoodsUnitLookUp", x as []);
        });
    }
  }
  setColumnAttribute(): void {
    super.setColumnAttribute();
    this.ProductConversionStandardDetailColumns = this.getDetailControlModels("ProductConversionStandardDetails");
  }
}
